/*
 * @Author: me@renhaiwei.cn
 * @Date: 2018-07-26 15:21:15
 * @Last Modified by: me@renhaiwei.cn
 * @Last Modified time: 2018-08-01 16:01:51
 */
import axios from 'axios';
import cookie from 'vue-cookie';
import func from '@/assets/scripts/func';

axios.defaults.baseURL = process.env.BASE_API;
axios.defaults.timeout = 5000;

/**
 * 拦截请求接口时
 */
axios.interceptors.request.use(function (req) {
    if (func.isSetCookie('_ibl')) {
        req.headers.authorization = cookie.get('_ibl');
    }
    return req;
});

// 拦截接口相应时
axios.interceptors.response.use(function(res){
    let authorization = res.headers.authorization;
    if ((authorization != undefined) && authorization != cookie.get('_ibl')) {
        cookie.set('_ibl', authorization);
    }
    return res;
});
export default axios;



// WEBPACK FOOTER //
// ./src/assets/scripts/api.js